import styled from "@emotion/styled";
import { CheckboxContainerProps } from "./Checkbox.types";
import { colorGuide } from "../../theme/colors";
import { generateCheckBoxStyles } from "../../utils";

export const CheckboxLabel = styled.label`
  cursor: pointer;
`;

const BaseInput = styled.input`
  display: none;
`;

export function CheckboxStyled(props: any) {
  return <BaseInput type="checkbox" {...props} />;
}

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => generateCheckBoxStyles({ ...props })}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

export const CheckIcon = styled.i`
  color: ${() => colorGuide.lightComponents.checkbox.color};
`;
